import { http } from "./client";

export const fetchErrorLogs = (params) => http.get("ErrorLogs", { params });
